const currencyArray = [
  {
    name: '₽',
    key: 'rur',
  },
  {
    name: '$',
    key: 'usd',
  },
  {
    name: '€',
    key: 'eur',
  },
];

export const currencyByKey = currencyArray.reduce((acc, item) => {
  acc[item.key] = item.name;

  return acc;
}, {});

export default currencyArray;
